export default __webpack_public_path__ + "static/media/SSANGYONG.06010cf3.png";